<div>
  <h1 data-contentid="test1" tabindex={0}>Health check</h1>
  <p data-contentid="test2" tabindex={0}>CLIENT IS RUNNING</p>
</div>
